import { gql } from '@apollo/client';
import CHECKOUT_FRAGMENT from '@/fragments/checkout';

const UPDATE_CHECKOUT_MUTATION = gql`
${CHECKOUT_FRAGMENT}
mutation updateCheckout(
    $checkoutId: ID!
    $orderType: OrderType!
    $pricingType: PricingType!
    $retailerId: ID!
) {
    updateCheckout(
        checkoutId: $checkoutId
        orderType: $orderType
        pricingType: $pricingType
        retailerId: $retailerId
    ) {
        ...checkoutFragment
    }
}`;

export default UPDATE_CHECKOUT_MUTATION;